<script>
	import Controlador from "../controlador.svelte";
	import {beforeUpdate, onMount} from "svelte";
	import {docs,logueo} from "../store.js";
	import Comparador from '../componentes/comparador.svelte';
import { replace } from "svelte-spa-router";
	let c;
	let muestra = 1;
	let nombre = "Año";
	let dataSM = [],dataC = [],dataSF= [],dataG=[];
	let dias = {};
	let labels=[];
	let config = {
		type: "line",
		maintainAspectRatio: false,
		options:{
			legend: {
				display: false,
			},
			tooltips:{
				callbacks:{
					label: function(tooltipItems, data){
						return '$' + tooltipItems.yLabel;
					}
				}
			},
			scales: {
        xAxes: [{
					gridLines: false,
					scaleLabel: false,
					ticks: {
						display: false
					}
				}],
				yAxes: [{
					gridLines: false,
					scaleLabel: false,
					ticks: {
						display: false
					}
				}]
			}
		}
	};
	let ctx,graph;
	let mes = [
		'Enero','Febrero','Marzo',
		'Abril','Mayo','Junio',
		'Julio','Agosto','Septiembre',
	'Octubre','Noviembre','Diciembre'
	];
	function obtenerSemana(d) {
		// 1) Convert date to Y M D
		var Y = d.getFullYear();
		var M = d.getMonth();
		var D = d.getDate();
		
		// 2) Find out if Y is a leap year
		var isLeapYear = (Y % 4 == 0  &&  Y % 100 != 0) || Y % 400 == 0;
		
		// 3) Find out if Y-1 is a leap year
		var lastYear = Y - 1;
		var lastYearIsLeap = (lastYear % 4 == 0  &&  lastYear % 100 != 0) || lastYear % 400 == 0;
		
		// 4) Find the Day of Year Number for Y M D
		var month = [0,31,59,90,120,151,181,212,243,273,304,334];
		var DayOfYearNumber = D + month[M];
		if(isLeapYear && M > 1)
			DayOfYearNumber++;
		
		// 5) Find the weekday for Jan 1 (monday = 1, sunday = 7)
		var YY = (Y-1) % 100; // ...
		var C = (Y-1) - YY; // get century
		var G = YY + YY/4; // ...
		var Jan1Weekday = 1 + (((((C / 100) % 4) * 5) + G) % 7);
		
		// 6) Find the weekday for Y M D
		var H = DayOfYearNumber + (Jan1Weekday - 1);
		var Weekday = 1 + ((H -1) % 7);
		
		var YearNumber = Y;
		var WeekNumber;
		// 7) Find if Y M D falls in YearNumber Y-1, WeekNumber 52 || 53
		if (DayOfYearNumber <= (8-Jan1Weekday) && Jan1Weekday > 4)
		{
			YearNumber = Y - 1;
			if (Jan1Weekday == 5 || (Jan1Weekday == 6 && isLeapYear))
			{
				WeekNumber = 53;
			} else
			{ 
				WeekNumber = 52;
			}
		}
		
		// 8) Find if Y M D falls in YearNumber Y+1, WeekNumber 1
		if (YearNumber == Y)
		{
			var I = 365;
			if (isLeapYear)
			{ 
				var I = 366;
			}
			if (I - DayOfYearNumber < 4 - Weekday)
			{
				YearNumber = Y + 1;
				WeekNumber = 1;
			}
		}
		
		// 9) Find if Y M D falls in YearNumber Y, WeekNumber 1 through 53
		if (YearNumber == Y)
		{
			var J = DayOfYearNumber + (7 - Weekday) + (Jan1Weekday -1);
			WeekNumber = J / 7;
			if (Jan1Weekday > 4)
			{
				WeekNumber--;
			}
		}
		
		return WeekNumber;
	};
	function cambiar(){
		if (muestra == 2){
			muestra = 3;
			nombre = "Semana";

		} else if (muestra == 0) {
			muestra = 1;
			nombre = "Año";
		}
		else if (muestra == 1) {
			muestra = 2;
			nombre = "Mes";
		}
		else if (muestra == 3) {
			muestra = 0;
			nombre = "Día";
		}
	}
	onMount(async ()=>{
		await c.actualizarDocs();
		ctx = document.getElementById("todos").getContext("2d");
		graph = new Chart(ctx,config);
		if (!$logueo){
			replace('/');
		}
	})
	beforeUpdate(()=>{
		if (graph){
			let cajas = $docs.filter((el)=>el._id.includes(`registro:`));
			if (nombre == "Día"){
				dias = {};
				labels = [];
				cajas.forEach((el)=>{
					let fecha = new Date(el.fecha);
					let fecha2 = new Date(el.fecha);
					let hoy = new Date();
					hoy.setHours(0,0,0,0);
					fecha.setHours(0,0,0,0);
					if (fecha.getTime() == hoy.getTime()){
						if (dias[fecha2.getHours()]){
							dias[fecha2.getHours()].push(el);
						} else {
							dias[fecha2.getHours()] = [];
						}
					}
				})
				for (var key in dias){
					let ingreso = {
						'local:San Martin':0,
						'local:Santa Fe':0,
						'local:Costa':0,
						'local:Guemes':0
					};
					let gasto = {
						'local:San Martin':0,
						'local:Santa Fe':0,
						'local:Costa':0,
						'local:Guemes':0
					};
					dias[key].forEach((reg)=>{
						switch(reg.tipo){
							case "Ingreso":
								ingreso[reg.idLocal] += reg.monto;
								break;
							case "Gasto":
								gasto[reg.idLocal] += reg.monto;
								break;
							case "Pago":
								gasto[reg.idLocal] += reg.monto;
								break;
						}
					})
					let ff = new Date(Number(key));
					labels.push(`${key}:00Hs`);
					dataSM.push(ingreso['local:San Martin']);
					dataSF.push(ingreso['local:Santa Fe']);
					dataC.push(ingreso['local:Costa']);
					dataG.push(ingreso['local:Guemes']);
				}
				config.data = {
					labels: labels,
					datasets: [
						{
							backgroundColor: "rgba(255, 99, 132,0.1)",
							borderColor: "rgb(255, 99, 132)",
							data: dataSM
						},
						{
							backgroundColor: "rgba(246, 153, 63,0.1)",
							borderColor: "rgb(246, 153, 63)",
							data: dataC
						},
						{
							backgroundColor: "rgba(101, 116, 205,0.1)",
							borderColor: "rgb(101, 116, 205)",
							data: dataSF
						},
						{
							backgroundColor: "rgba(101, 205, 116,0.1)",
							borderColor: "rgb(101, 205, 116)",
							data: dataG
						}
					]
				}
				graph.update();
			}//fin de dia
			if (nombre == "Semana"){
				dias = {};
				labels = [];
				cajas.forEach((el)=>{
					let fecha = new Date(el.fecha);
					let hoy = new Date();
					fecha.setHours(0,0,0,0);
					if (obtenerSemana(hoy) == obtenerSemana(fecha)){
						if (dias[fecha.getTime()]){
							dias[fecha.getTime()].push(el);
						} else {
							dias[fecha.getTime()] = [];
						}
					}
				})
				for (var key in dias){
					let ingreso = {
						'local:San Martin':0,
						'local:Santa Fe':0,
						'local:Costa':0,
						'local:Guemes':0
					};
					let gasto = {
						'local:San Martin':0,
						'local:Santa Fe':0,
						'local:Costa':0,
						'local:Guemes':0
					};
					dias[key].forEach((reg)=>{
						switch(reg.tipo){
							case "Ingreso":
								ingreso[reg.idLocal] += reg.monto;
								break;
							case "Gasto":
								gasto[reg.idLocal] += reg.monto;
								break;
							case "Pago":
								gasto[reg.idLocal] += reg.monto;
								break;
						}
					})
					let ff = new Date(Number(key));
					labels.push(`${ff.getDate()}/${ff.getMonth()+1}/${ff.getFullYear()}`);
					dataSM.push(ingreso['local:San Martin']);
					dataSF.push(ingreso['local:Santa Fe']);
					dataC.push(ingreso['local:Costa']);
					dataG.push(ingreso['local:Guemes']);
				}
				config.data = {
					labels: labels,
					datasets: [
						{
							backgroundColor: "rgba(255, 99, 132,0.1)",
							borderColor: "rgb(255, 99, 132)",
							data: dataSM
						},
						{
							backgroundColor: "rgba(246, 153, 63,0.1)",
							borderColor: "rgb(246, 153, 63)",
							data: dataC
						},
						{
							backgroundColor: "rgba(101, 116, 205,0.1)",
							borderColor: "rgb(101, 116, 205)",
							data: dataSF
						},
						{
							backgroundColor: "rgba(101, 205, 116,0.1)",
							borderColor: "rgb(101, 205, 116)",
							data: dataG
						}
					]
				}
				graph.update();
			}//fin de semana
			if (nombre == "Mes"){
				dias = {};
				labels = [];
				cajas.forEach((el)=>{
					let fecha = new Date(el.fecha);
					let hoy = new Date();
					fecha.setHours(0,0,0,0);
					if (fecha.getMonth() == hoy.getMonth()){
						if (dias[fecha.getTime()]){
							dias[fecha.getTime()].push(el);
						} else {
							dias[fecha.getTime()] = [];
						}
					}
				})
				for (var key in dias){
					let ingreso = {
						'local:San Martin':0,
						'local:Santa Fe':0,
						'local:Costa':0,
						'local:Guemes':0
					};
					let gasto = {
						'local:San Martin':0,
						'local:Santa Fe':0,
						'local:Costa':0,
						'local:Guemes':0
					};
					dias[key].forEach((reg)=>{
						switch(reg.tipo){
							case "Ingreso":
								ingreso[reg.idLocal] += reg.monto;
								break;
							case "Gasto":
								gasto[reg.idLocal] += reg.monto;
								break;
							case "Pago":
								gasto[reg.idLocal] += reg.monto;
								break;
						}
					})
					let ff = new Date(Number(key));
					labels.push(`${ff.getDate()}/${ff.getMonth()+1}/${ff.getFullYear()}`);
					dataSM.push(ingreso['local:San Martin']);
					dataSF.push(ingreso['local:Santa Fe']);
					dataC.push(ingreso['local:Costa']);
					dataG.push(ingreso['local:Guemes']);
				}
				config.data = {
					labels: labels,
					datasets: [
						{
							backgroundColor: "rgba(255, 99, 132,0.1)",
							borderColor: "rgb(255, 99, 132)",
							data: dataSM
						},
						{
							backgroundColor: "rgba(246, 153, 63,0.1)",
							borderColor: "rgb(246, 153, 63)",
							data: dataC
						},
						{
							backgroundColor: "rgba(101, 116, 205,0.1)",
							borderColor: "rgb(101, 116, 205)",
							data: dataSF
						},
						{
							backgroundColor: "rgba(101, 205, 116,0.1)",
							borderColor: "rgb(101, 205, 116)",
							data: dataG
						}
					]
				}
				graph.update();
			}//fin de mes
			if (nombre == "Año"){
				dias = {};
				labels = [];
				cajas.forEach((el)=>{
					let fecha = new Date(el.fecha);
					let hoy = new Date();
					if (fecha.getFullYear() == hoy.getFullYear()){
						if (dias[fecha.getMonth()]){
							dias[fecha.getMonth()].push(el);
						} else {
							dias[fecha.getMonth()] = [];
						}
					}
				})
				for (var key in dias){
					let ingreso = {
						'local:San Martin':0,
						'local:Santa Fe':0,
						'local:Costa':0,
						'local:Guemes':0
					};
					let gasto = {
						'local:San Martin':0,
						'local:Santa Fe':0,
						'local:Costa':0,
						'local:Guemes':0
					};
					dias[key].forEach((reg)=>{
						switch(reg.tipo){
							case "Ingreso":
								ingreso[reg.idLocal] += reg.monto;
								break;
							case "Gasto":
								gasto[reg.idLocal] += reg.monto;
								break;
							case "Pago":
								gasto[reg.idLocal] += reg.monto;
								break;
						}
					})
					labels.push(`${mes[key]}`);
					dataSM.push(ingreso['local:San Martin']);
					dataSF.push(ingreso['local:Santa Fe']);
					dataC.push(ingreso['local:Costa']);
					dataG.push(ingreso['local:Guemes']);
				}
				config.data = {
					labels: labels,
					datasets: [
						{
							backgroundColor: "rgba(255, 99, 132,0.1)",
							borderColor: "rgb(255, 99, 132)",
							data: dataSM
						},
						{
							backgroundColor: "rgba(246, 153, 63,0.1)",
							borderColor: "rgb(246, 153, 63)",
							data: dataC
						},
						{
							backgroundColor: "rgba(101, 116, 205,0.1)",
							borderColor: "rgb(101, 116, 205)",
							data: dataSF
						},
						{
							backgroundColor: "rgba(101, 205, 116,0.1)",
							borderColor: "rgb(101, 205, 116)",
							data: dataG
						}
					]
				}
				graph.update();
			}//fin de año
		}
	})
	let botones = [
		{nombre:"Locales",icon:"ri-store-2-line text-3xl",href:"#/locales"},
		{nombre:"Deposito",icon:"ri-home-6-line text-3xl",href:"#/deposito/-1"},
		{nombre:"Empleados",icon:"ri-user-2-line text-3xl",href:"#/empleados"},
		{nombre:"Clientes",icon:"ri-group-line text-3xl",href:"#/clientes"},
		{nombre:"Calendario",icon:"ri-calendar-line text-3xl",href:"#/calendario"},
	//	{nombre:"Cuenta",icon:"ri-user-smile-line text-3xl",href:"#/cuenta"}
	]
</script>
<Controlador bind:this={c} />
<div class="p-4 w-full sm:w-3/4">
	<div class="w-full flex flex-col sm:flex-row items-center justify-between">
		{#each botones as boton}
			<a href={boton.href} class="m-2 p-4 w-full text-white bg-red-500 cursor-pointer flex flex-col items-center justify-center rounded shadow hover:bg-red-400 hover-shadow-2">
				<i class={boton.icon} />
				{boton.nombre}
			</a>
		{/each}
	</div>
	<Comparador />
</div>
